import {createRender} from '@packages/systems/render';
import DesignerExpansion from './DesignerExpansion';
import React from 'react';

const Render = createRender(DesignerExpansion);

export const RenderDesignerCanvas = (
  props: React.ComponentProps<typeof Render>
) => <Render {...props} />;
